import { useAppSelector } from '@/shared/lib/redux';

/**
 * Хук доступа к состоянию авторизации администратора
 */
export const useAdminAuth = () => {
  const auth = useAppSelector(state => state.adminSession.auth);

  return {
    auth,
    isAdminLoggedIn: Boolean(auth?.['access-token'] && auth.client && auth.uid)
  };
};
